import {
  Context,
  useCategoryFactory,
  UseCategoryFactoryParams
} from '@vue-storefront/core';
import type { Category } from '@bee-hole/api';
import type {
  UseCategorySearchParams as SearchParams
} from '../types';
import { useApiError } from '../useApiError';
const params: UseCategoryFactoryParams<Category, SearchParams> = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  provide: () => ({
    useApiError: useApiError()
  }),
  categorySearch: async (context: Context, { ...params }) => {
    const res = await context.$xbuy.api.getCategory(params);
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      // throw new Error(res.message);
    }
    return res.data;
  }
};

export const useCategory = useCategoryFactory<Category, SearchParams>(params);
